"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconUser from "@/app/(components)/generics/Icons/IconUser";
import { useCanRunPaidActions } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageParams } from "@/app/types/common/DefaultProps";
import { URLs } from "@/app/utils/URLs";
import { Routes } from "@/app/vars/Routes";
import styles from "./NoAvatarCard.module.css";

type Props = {
  params: PageParams;
};

export default function NoAvatarCard(props: Props) {
  const T = useT();
  const { params } = props;

  const canRunPaidActions = useCanRunPaidActions();

  return (
    <div className={styles.card}>
      <div className={styles.iconContainer}>
        <IconUser size={28} />
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            {T(
              canRunPaidActions
                ? TKey.PROSPECT_SEARCH_NO_AVATAR_TITLE
                : TKey.PROSPECT_SEARCH_NO_AVATAR_TITLE_MEMBER,
            )}
          </h2>
          {canRunPaidActions && (
            <span className={styles.badge}>{T(TKey.PROSPECT_SEARCH_NO_AVATAR_BADGE)}</span>
          )}
        </div>
        <p className={styles.description}>
          {T(
            canRunPaidActions
              ? TKey.PROSPECT_SEARCH_NO_AVATAR_DESCRIPTION
              : TKey.PROSPECT_SEARCH_NO_AVATAR_DESCRIPTION_MEMBER,
          )}
        </p>
        <div className={styles.actions}>
          <Button
            params={params}
            min={true}
            isLink={true}
            href={URLs.pathOf(Routes.PROTECTED.CLIENT_AVATAR)}
            type={ButtonType.PRIMARY}
            text={
              T(
                canRunPaidActions
                  ? TKey.PROSPECT_SEARCH_NO_AVATAR_BUTTON
                  : TKey.PROSPECT_SEARCH_NO_AVATAR_BUTTON_MEMBER,
              ) as string
            }
          />
        </div>
      </div>
    </div>
  );
}
